
import { mapActions, mapState } from 'vuex';

export default {
    name: 'SiteCommentsComment',
    props: {
        /**
         * The vuex auth object
         */
        auth: {
            type: Object,
            required: true,
        },
        /**
         * hide reply functionality?
         */
        closed: {
            type: Boolean,
            default: false,
        },
        /**
         * A Comment object
         */
        comment: {
            type: Object,
            default() {
                return {};
            },
        },
        /**
         * Should we filter contact details on submission?
         */
        filterContactDetails: {
            type: Boolean,
            default: false,
        },
        /**
         * Is theis a comment form on job page
         */
        isJobComment: {
            type: Boolean,
            default: false,
        },
        /**
         * The api endpoint for comments
         */
        url: {
            type: String,
            required: true,
        },
        /**
         * Do we want to show the action bar?
         */
        showActions: {
            type: Boolean,
            default: true,
        },
        /**
         * Do we want to show the replies?
         */
        showReplies: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            mediaViewerStartIndex: 0,
            replyUrl: `${this.url}?parent_id=${this.comment.id}`,
            reportableEndpoint: `${this.url}/${this.comment.id}/report`,
            showMediaViewer: false,
            showReply: false,
        };
    },
    computed: {
        ...mapState(['isMobile']),
        canEdit() {
            return this.auth.user && (this.auth.user.id === this.comment.user.id || this.auth.user.role === 'admin');
        },
        isAdmin() {
            return this.auth.user && this.auth.user.isAdmin;
        },
        profileLink() {
            return this.isJobComment ? {} : this.comment.link || { name: 'profile-user', params: { user: this.comment.user.slug } };
        },
        commentParam() {
            return this.$route.query.comment ? parseInt(this.$route.query.comment, 10) : null;
        },
    },
    mounted() {
        if (this.$refs.highlight) {
            this.$refs.highlight.$el.scrollIntoView();
        }
    },
    methods: {
        ...mapActions(['showConfirm', 'showReportable']),
        addComment(data, parent) {
            /**
             * Pass the comment up the chain
             *
             * @type {object}
             */
            this.$emit('add', data, parent);
            this.showReply = false;
        },
        confirmDelete(comment) {
            this.showConfirm({
                callback: () => {
                    this.deleteComment(comment);
                },
                text: this.$t('comments.confirm_delete'),
            });
        },
        deleteComment(comment, parent) {
            /**
             * Remove this comment
             *
             * @type {object}
             */
            this.$emit('remove', comment, parent);
        },
    },
};
